/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Per_Month_LongInputs */

const en_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/month`)
};

const de_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/Monat`)
};

const fr_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mois`)
};

const es_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mes`)
};

const it_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/mese`)
};

const nl_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/maand`)
};

const pl_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/miesiąc`)
};

const fi_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/kuukausi`)
};

const da_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/måned`)
};

const sv_pricing_per_month_long = /** @type {(inputs: Pricing_Per_Month_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`/månad`)
};

/**
* | output |
* | --- |
* | "/month" |
*
* @param {Pricing_Per_Month_LongInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const pricing_per_month_long = /** @type {((inputs?: Pricing_Per_Month_LongInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Per_Month_LongInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_pricing_per_month_long(inputs)
	if (locale === "fr") return fr_pricing_per_month_long(inputs)
	if (locale === "es") return es_pricing_per_month_long(inputs)
	if (locale === "it") return it_pricing_per_month_long(inputs)
	if (locale === "nl") return nl_pricing_per_month_long(inputs)
	if (locale === "pl") return pl_pricing_per_month_long(inputs)
	if (locale === "fi") return fi_pricing_per_month_long(inputs)
	if (locale === "da") return da_pricing_per_month_long(inputs)
	if (locale === "sv") return sv_pricing_per_month_long(inputs)
	return en_pricing_per_month_long(inputs)
});